import React from 'react';
import { motion } from 'framer-motion';
import { FiCheckCircle, FiPhone, FiMessageSquare } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function Hero() {
  return (
    <div className="relative min-h-screen flex items-center justify-center pt-20">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: "url('https://images.unsplash.com/photo-1500382017468-9049fed747ef?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80')" }}
      >
        <div className="absolute inset-0 bg-stone-900/75 mix-blend-multiply"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center gap-12 pt-8 pb-16">
        {/* Text Content */}
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="flex-1 text-center md:text-left"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-500/20 border border-brand-400/30 text-brand-100 mb-6 backdrop-blur-sm">
            <span className="w-2 h-2 rounded-full bg-brand-400 animate-pulse"></span>
            <span className="text-sm font-medium tracking-wide uppercase">Direct Land Buyers</span>
          </div>
          
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif font-bold text-white leading-tight mb-6">
            Sell Your Land <br/>
            <span className="text-brand-400">Fast & Hassle-Free</span>
          </h1>
          
          {/* Personalized Hero Copy */}
          <p className="text-lg md:text-xl text-stone-200 mb-8 max-w-2xl mx-auto md:mx-0 leading-relaxed">
            Hi, I'm Stu! I know selling land can feel like a corporate maze. I buy vacant land directly from owners to help you skip the agents, avoid the waiting game, and get a fair cash offer with a personal touch.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4 justify-center md:justify-start mb-8">
            <a 
              href="tel:2512431403"
              className="w-full sm:w-auto px-8 py-4 bg-brand-600 hover:bg-brand-500 text-white rounded-lg font-bold text-lg transition-all shadow-lg hover:shadow-brand-500/25 flex items-center justify-center gap-3"
            >
              <SafeIcon icon={FiPhone} className="text-xl" />
              Call / Text Stu Now
            </a>
            <p className="text-stone-300 text-sm flex items-center gap-2">
              <SafeIcon icon={FiCheckCircle} className="text-brand-400" /> Close in under 30 days
            </p>
          </div>

          {/* Trust Badge with Profile Pic */}
          <div className="flex items-center gap-4 justify-center md:justify-start mt-8 pt-6 border-t border-stone-700/50">
            <img 
              src="https://i.ibb.co/QFNLjPPw/Stu.webp" 
              alt="Stu Donald" 
              className="w-14 h-14 rounded-full border-2 border-brand-500 object-cover shadow-lg"
            />
            <div className="text-left">
              <p className="text-white font-medium text-lg leading-tight">Stu Donald</p>
              <p className="text-stone-400 text-sm">Land Specialist, Land Quick</p>
            </div>
          </div>
        </motion.div>

        {/* Trust Indicators / Mini Contact Card Right Side */}
        <motion.div 
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="flex-1 w-full max-w-md hidden lg:block"
        >
          <div className="bg-white p-8 rounded-2xl shadow-2xl text-center border-t-4 border-brand-500">
            <div className="w-16 h-16 bg-brand-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <SafeIcon icon={FiMessageSquare} className="text-3xl text-brand-600" />
            </div>
            <h3 className="text-2xl font-bold text-stone-800 mb-2">Skip the Forms</h3>
            <p className="text-stone-500 mb-8 text-sm px-4">
              Talk to a real person. Call or text Stu directly to get your cash offer process started instantly.
            </p>
            
            <a 
              href="tel:2512431403"
              className="flex items-center justify-center gap-3 w-full px-6 py-4 bg-stone-900 hover:bg-stone-800 text-white rounded-xl font-bold text-xl transition-colors shadow-md"
            >
              <SafeIcon icon={FiPhone} className="text-brand-400" />
              (251) 243-1403
            </a>
            <p className="text-stone-400 text-xs mt-4 uppercase tracking-wider font-semibold">
              No Obligation • 100% Free
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
}